import { useTranslation } from 'react-i18next';
import { Chip } from '@/shared/ui/chips/Chip';

type Props = { amount: number; isPaid: boolean; className?: string };

export const ChargeStatusChip = ({ amount, isPaid, className }: Props) => {
  const { t } = useTranslation();
  if (Number(amount) === 0) {
    return (
      <Chip tone="bg-slate-100 text-slate-700 border-slate-200" className={className}>
        {t('cargoIds.detail.charges.statusFree')}
      </Chip>
    );
  }
  return (
    <Chip
      tone={
        isPaid
          ? 'bg-emerald-100 text-emerald-800 border-emerald-200'
          : 'bg-amber-100 text-amber-800 border-amber-200'
      }
      className={className}
    >
      {isPaid ? t('cargoIds.detail.charges.statusPaid') : t('cargoIds.detail.charges.statusUnpaid')}
    </Chip>
  );
};
